<div *ngIf="cart" fxLayout="column" class="my-2">
        <div style="font-size: larger;">{{translateHelper.localize(cart.companyData?.name)}}</div>
        <div fxLayout="column" class="my-2">

            <table class="cart__table cart-table vendor">
                <thead class="cart-table__head">
                    <tr class="cart-table__row">
                        <th class="cart-table__column cart-table__column--image" style="border-left: none;">{{"item"|translate}}</th>
                        <th class="cart-table__column cart-table__column--product">{{"item_details"|translate}}</th>
                        <th class="cart-table__column cart-table__column--price">{{"product_code"|translate}}</th>
                        <th class="cart-table__column cart-table__column--quantity" style="border-right: none;">{{"amount"|translate}}</th>
                    </tr>
                </thead>
                <tbody class="cart-table__body">
                        <tr *ngFor="let item of items; let i = index" class="cart-table__row">
                            <td class="cart-table__column cart-table__column--image" style="border-left: none;">
                                <div *ngIf="item.image" >
                                  <a [routerLink]="cart.items[i]?.product?.type && cart.items[i].product?.seo?.slug?['/'+cart.items[i]?.product?.layout||cart.items[i]?.product?.type,cart.items[i].product?.seo?.slug]:null">
                                    <img style="height: 74px; margin: 8px;" [routerLink]="['/'+cart.items[i]?.product?.type,cart.items[i]?.product?.seo?.slug]"
                                        [src]="item.image" alt=""></a>
                            </div>
                            </td>
                            <td class="cart-table__column cart-table__column--product">
                                <a class="cart-table__product-name" style="font-weight: bold;"
                                [routerLink]="cart.items[i]?.product?.type && cart.items[i].product?.seo?.slug?['/'+cart.items[i]?.product?.layout||cart.items[i]?.product?.type,cart.items[i].product?.seo?.slug]:null">{{ item.item }}</a>

                                <app-options-details [options]="item.options"  [variant]="item.variant"></app-options-details>
                                <app-booking-details [serviceData]="item.serviceData" [dateType]="item.product?.dateType" [timeType]="item.product?.timeType"></app-booking-details>

                            </td>
                            <td class="cart-table__column cart-table__column--price" data-title="Product Code">
                                {{ item.code }}</td>
                            <td class="cart-table__column cart-table__column--quantity" style="border-right: none;" data-title="Quantity">
                                <app-input-number [formControl]="item.quantity" [min]="item.minQuantity"
                                (updatedItem)="updateValue($event,item.itemId)"></app-input-number>
                            </td>

                        </tr>
                </tbody>
            </table>
        </div>
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutAlign.lt-sm="center center" style="width: 100%;">

            <button type="button" (click)="submit(cart._id)"
            m  class="btn btn-primary mx-2" [ngStyle.xs]="{'width': '80%'}"> {{"request_quotaiton"|translate}} </button>

        </div>

</div>
<mat-divider></mat-divider>

